/**
 * VIN (Fahrgestellnummer) validation utilities.
 * Supports worldwide VIN formats according to ISO 3779.
 */

import i18n from 'i18next';

export type VinValidationResult = {
    isValid: boolean;
    message: string;
    messageType: 'success' | 'warning' | 'error';
};

/**
 * Validates a VIN and returns detailed validation result with German messages.
 * Hard requirement: minimum 3 characters.
 * Validates format and check digit according to ISO 3779.
 */
export function validateVin(vin: string | undefined | null): VinValidationResult {
    const cleanVin = (vin || '').trim();

    if (cleanVin.length === 0) {
        return {
            isValid: true,
            message: '',
            messageType: 'warning',
        };
    }

    if (cleanVin.length < 17) {
        return {
            isValid: false,
            message: i18n.t('vin.enterComplete'),
            messageType: 'error',
        };
    }

    if (cleanVin.length > 17) {
        return {
            isValid: false,
            message: i18n.t('vin.maxLength'),
            messageType: 'error',
        };
    }

    return {
        isValid: true,
        message: '',
        messageType: 'success',
    };
}

